import React, { ReactNode } from "react"

import { DGText } from "../../../components/common/DGText"
import { s } from "../../../utilities/common"
import { theme, TI } from "../../../utilities/theme"

interface ChildrenProp {
  children: ReactNode
}
export const PTitle = ({
  children,
  noMargin,
}: ChildrenProp & { noMargin?: boolean }) => {
  return (
    <DGText
      tx={TI.H05tv}
      sx={{
        color: theme.palette.white.main,
        mb: !noMargin ? s("22px") : undefined,
      }}
    >
      {children}
    </DGText>
  )
}
export const PText = ({ children }: ChildrenProp) => {
  return (
    <DGText
      tx={TI.Subheadline05tv}
      sx={{
        color: theme.palette.white[70],
        whiteSpace: "pre-wrap",
      }}
    >
      {children}
    </DGText>
  )
}
